import { useAppSelector } from "../../../../../store/reduxHooks";
import {
  SELECT_REQUEST_BANK_DOCUMENTS,
  SELECT_REQUEST_BANK_ID,
} from "../../../../../store/selectors/requestAppSelector";
import {
  DocumentKkb,
  DocumentToSign,
  DocumentType,
} from "../../../../../store/slice/requestAppSlise/requestAppSlise";
import {
  onClickDownloadApplicationFile,
  onClickDownloadApplicationFileFromBank,
} from "../../../../../utils/utilities/Downloads";
import {
  getDocumentTitleDown,
  getDocumentTitleDownOther,
} from "../../../../../utils/utilities/getDocumentFIleName";
import classes from "../style/DocListComissionStatuses.module.css";
import docListClasses from "../../style/DocListForDownload.module.css";
import { ApplicationDownloadFileSignStatus } from "../../../../Ui/Application/ApplicationDownloadFileComponents/ApplicationDownloadFIleSignStatus/ApplicationDownloadFileSignStatus";
import { ApplicationDownloadFile } from "../../../../Ui/Application/ApplicationDownloadFileComponents/ApplicationDownloadFile/ApplicationDownloadFile";

export const DocListCommissionStatusHideSignForDownload = () => {
  const data = useAppSelector(SELECT_REQUEST_BANK_ID);
  const docs = useAppSelector(SELECT_REQUEST_BANK_DOCUMENTS);
  const applicationBankId = Number(data.id);
  return (
    <div>
      {docs?.map((documentDto: DocumentToSign | DocumentType<DocumentKkb>) => {
        if (Object.hasOwn(documentDto, "type_doc")) {
          const newDto = documentDto as DocumentToSign;
          return (
            <ApplicationDownloadFile
              className={docListClasses.documentItem}
              title={<span className={classes.title}>{newDto.name}</span>}
              icon={false}
              subtitle={
                <span className={classes.subtitle}>
                  {getDocumentTitleDown(newDto)}
                </span>
              }
              onDownloadClick={() =>
                onClickDownloadApplicationFile(newDto, applicationBankId)
              }
            />
          );
        }
        if (Object.hasOwn(documentDto, "document")) {
          const newDto = documentDto as DocumentType<DocumentKkb>;
          return (
            <ApplicationDownloadFileSignStatus
              docSigned={!!newDto.document?.sign_file?.length}
              icon={false}
              className={docListClasses.documentItem}
              title={<span className={classes.title}>{newDto.name}</span>}
              subtitle={
                <span className={classes.subtitle}>
                  {getDocumentTitleDownOther(newDto)}
                </span>
              }
              onDownloadClick={() =>
                onClickDownloadApplicationFileFromBank(
                  newDto,
                  applicationBankId,
                )
              }
            />
          );
        }
      })}
    </div>
  );
};
